exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1PB2ofm8RSB5psM_VAChNK {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(9,30,66,0.6);\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s;\n  z-index: 3;\n}\n._1PB2ofm8RSB5psM_VAChNK._1yUpp5pF9zPxu6Of0AbssT {\n  opacity: 1;\n  pointer-events: all;\n}\n", ""]);

// Exports
exports.locals = {
	"base": "_1PB2ofm8RSB5psM_VAChNK",
	"active": "_1yUpp5pF9zPxu6Of0AbssT"
};